// Anuva product card: wishlist hearts and quick add (single-variant products).
import { CartAddEvent } from '@theme/events';

const root = window.Shopify?.routes?.root || '/';

const readWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem('wishlist_items') || '[]');
  } catch (e) {
    return [];
  }
};

const syncHearts = () => {
  const items = readWishlist();
  document.querySelectorAll('[data-anuva-wishlist]').forEach((btn) => {
    btn.setAttribute('aria-pressed', String(items.includes(btn.dataset.anuvaWishlist)));
  });
};

const toggleWishlist = (handle) => {
  const current = readWishlist();
  const items = current.includes(handle) ? current.filter((h) => h !== handle) : [...current, handle];
  try {
    localStorage.setItem('wishlist_items', JSON.stringify(items));
    localStorage.setItem('wishlist_count', String(items.length));
  } catch (e) {}
  const count = document.getElementById('wishlist-count');
  if (count) count.innerText = String(items.length);
  syncHearts();
};

const quickAdd = async (button) => {
  const labels = button.querySelectorAll('[data-anuva-label]');
  const originals = [...labels].map((l) => l.textContent);
  const setLabels = (text) => labels.forEach((l, i) => (l.textContent = text ?? originals[i]));
  button.disabled = true;
  button.classList.add('is-loading');
  button.setAttribute('aria-busy', 'true');
  setLabels('Adding…');
  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.anuvaAdd), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.dispatchEvent(
      new CartAddEvent(cart, 'anuva-product-card', {
        itemCount: cart.item_count,
        variantId: button.dataset.anuvaAdd,
        source: 'anuva-product-card',
      })
    );
    setLabels('Added');
    button.classList.add('is-added');
  } catch (e) {
    setLabels('Try again');
  } finally {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    setTimeout(() => {
      button.disabled = false;
      button.classList.remove('is-added');
      setLabels();
    }, 1800);
  }
};

if (!window.__anuvaProductCard) {
  window.__anuvaProductCard = true;
  syncHearts();
  document.addEventListener('shopify:section:load', syncHearts);
  // Re-sync hearts that arrive later (cart drawer re-renders, infinite scroll)
  let heartsQueued = false;
  new MutationObserver(() => {
    if (heartsQueued) return;
    heartsQueued = true;
    requestAnimationFrame(() => {
      heartsQueued = false;
      syncHearts();
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', (event) => {
    const heart = event.target.closest('[data-anuva-wishlist]');
    if (heart) return toggleWishlist(heart.dataset.anuvaWishlist);
    const add = event.target.closest('[data-anuva-add]');
    if (add && !add.disabled) quickAdd(add);
  });
}
